import { formatDateByCountry } from "@/app/helpers/dateHelper";
import { NormalPayment, PaymentRow } from "@/app/models/apiModels/payment";
import { PaymentType } from "@/app/models/enum/paymentType";
import { useShallow } from "zustand/react/shallow";
import React from "react";
import { doUseOrderStorageStore } from "@/stores/order-storage-store"; // <-- Make sure this import exists


interface PaymentDetailsProps {
  title: string;
  priceUnit: string;
  isCompany: boolean;
  paymentRows?: PaymentRow[];
  translation: any;
  country: string;
}

export const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  title,
  priceUnit,
  isCompany = false,
  paymentRows,
  translation,
  country
}) => {
  const { user } =
    doUseOrderStorageStore(
      useShallow((state) => ({
        user: state.user,
      }))
    );

  // Sortera rows baserat på sortOrder
  const sortedRows = paymentRows
    ? [...paymentRows].filter(row =>
      row.type !== PaymentType.RoundedAmount &&
      row.type !== PaymentType.RoundedVatAmount
    ).sort((a, b) => (a.sortorder ?? 99) - (b.sortorder ?? 99))
    : [];

  return (
    <div>
      {title && <h4 className="mt-4">{title}</h4>}
      <div className="w-full payment-details grid grid-cols-3">
        {sortedRows &&
          sortedRows.map(
            (row, index) =>
              <React.Fragment key={index}>
                <p className="font-bold text-small">
                  {row.type === PaymentType.Rent && translation.pages.order?.paymentContainer.rent}
                  {row.type === PaymentType.Insurance && translation.pages.order?.paymentContainer.insurance}
                  {row.type === PaymentType.Discount && translation.pages.order?.paymentContainer.discount}
                  {row.type === PaymentType.Rounding && translation.pages.order?.paymentContainer.rounding}
                  {row.type === PaymentType.Establishment && translation.pages.order?.paymentContainer.establishment}
                  {row.type === PaymentType.Vat && translation.pages.order?.paymentContainer.vat}
                  {row.type === PaymentType.DiscountVat && translation.pages.order?.paymentContainer.discountVat}
                </p>
                {row.type != PaymentType.Total ? (
                  <>
                    {row.from && row.type !== PaymentType.Establishment ? (
                      <p className="text-center text-small">
                        {`${formatDateByCountry(row.from, country)} - ${formatDateByCountry(row.to, country)}`}
                      </p>
                    ) : (
                      <p className="text-center text-small">&nbsp;</p>
                    )}
                    <p className={`text-end text-small ${!row.from ? "col-start-3" : ""}`}>
                      {`${row.amount.toFixed(2)} ${priceUnit}`}
                    </p>
                  </>
                ) : (
                  <>
                    <div className="col-span-3 inline-flex w-full font-bold justify-between border-y border-gs-grey">
                      <p className="my-1">{translation.pages.order?.paymentContainer.total}</p>
                      <p className="my-1">
                        {`${row.total.toFixed(2)} ${priceUnit}`}
                      </p>
                    </div>
                  </>
                )}
              </React.Fragment>
          )}
      </div>
    </div>
  );
};